var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeCampingCar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-5 {\n        mask: url(#mask);\n      }\n\n      .cls-6 {\n        filter: url(#luminosity-invert);\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-8 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-9 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-10 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-3 {\n        fill: #000;\n        fill-opacity: .6;\n      }\n\n      .cls-4 {\n        fill: #ad974f;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-invert",
    x: -197.1,
    y: -199.2,
    width: 894.2,
    height: 894.2,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "cm",
    values: "-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: -197.1,
    y: -199.2,
    width: 894.2,
    height: 894.2,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d9a84d97a5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -197.1,
    y: -199.2,
    width: 894.2,
    height: 894.2
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.5,
    y: 89.9,
    width: 467,
    height: 316
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 26.4,
    y: 90.6,
    width: 447.1,
    height: 215.9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18.2,
    y: 320.4,
    width: 463.5,
    height: 51.7
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 107.9,
    y: 354.2,
    width: 51.7,
    height: 50.9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 398,
    y: 354.2,
    width: 51.7,
    height: 50.9
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M473.5,305.8v-24.8c0-9.1-7.4-16.5-16.5-16.5h-74.5c-18.3,0-33.1-14.8-33.1-33.1v-33.1c0-13.7,11.1-24.8,24.8-24.8h41.4c13.7,0,24.8-11.1,24.8-24.8v-16.6c0-22.8-18.6-41.4-41.4-41.4h-106.7c-4.5,0-8.9,1.2-12.8,3.5l-25.7,15.4c-6.4,3.9-13.8,5.9-21.3,5.9H43.1c-9.1,0-16.6,7.4-16.6,16.6v8.3h289.7v-8.3c0-13.7,11.1-24.8,24.8-24.8h49.7c13.7,0,24.8,11.1,24.8,24.8s-11.1,24.8-24.8,24.8h-76c.9,2.6,1.5,5.4,1.5,8.3v140.7h157.3"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M481.8,372.1v-49.7h-165.5c0,13.7-11.1,24.8-24.8,24.8h-33.1c-13.7,0-24.8-11.1-24.8-24.8H18.2v49.7h75.3c3.8-18.9,20.6-33.1,40.5-33.1s36.7,14.2,40.5,33.1h208.6c3.8-18.9,20.6-33.1,40.5-33.1s36.7,14.2,40.5,33.1h17.4"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.1,355.5c-13.7,0-24.8,11.1-24.8,24.8s11.1,24.8,24.8,24.8,24.8-11.1,24.8-24.8-11.1-24.8-24.8-24.8"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M423.8,355.5c-13.7,0-24.8,11.1-24.8,24.8s11.1,24.8,24.8,24.8,24.8-11.1,24.8-24.8-11.1-24.8-24.8-24.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M399,132c0-4.6-3.7-8.3-8.3-8.3h-49.7c-4.6,0-8.3,3.7-8.3,8.3v8.3h57.9c4.6,0,8.3-3.7,8.3-8.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.3,198.2c0-13.7,11.1-24.8,24.8-24.8h49.7c13.7,0,24.8,11.1,24.8,24.8v33.1c0,13.7-11.1,24.8-24.8,24.8h-49.7c-13.7,0-24.8-11.1-24.8-24.8v-33.1ZM26.5,305.8h206.9v-140.7c0-2.9.6-5.7,1.5-8.3H26.5v149"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M250,322.4c0,4.6,3.7,8.3,8.3,8.3h33.1c4.6,0,8.3-3.7,8.3-8.3v-82.8h-49.7v82.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.1,239.6h49.7c4.6,0,8.3-3.7,8.3-8.3v-33.1c0-4.6-3.7-8.3-8.3-8.3h-49.7c-4.6,0-8.3,3.7-8.3,8.3v33.1c0,4.6,3.7,8.3,8.3,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M299.7,165.1c0-4.6-3.7-8.3-8.3-8.3h-33.1c-4.6,0-8.3,3.7-8.3,8.3v57.9h49.7v-57.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M374.2,190c-4.6,0-8.3,3.7-8.3,8.3v33.1c0,9.1,7.4,16.6,16.5,16.6h43.9l-32.2-57.9h-19.9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeCampingCar);
export default __webpack_public_path__ + "static/media/Icone-camping-car.dca903ebefdd8c425c0e28fb105daa79.svg";
export { ForwardRef as ReactComponent };